<template>
  <component :is="tag" v-bind="computedAttrs">
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "AppNavLink",

  props: {
    tag: {
      type: String,
      default: "router-link",
    },
    active: Boolean,
  },

  setup(_props, { attrs }) {
    const computedAttrs = computed(() => {
      const merged = { ...attrs };

      // Remove target if it equals "_self"
      if (merged.target === "_self") {
        delete merged.target;
      }

      return merged;
    });

    return {
      computedAttrs,
    };
  },
});
</script>
